import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class UserEditService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) {}

    edit(id, post): Observable<any> {
        const url = this.urlPrefix + 'users/' + id ;
        return this.httpClient
            .put(url, {
                email: post.email.value,
                firstName: post.firstName.value,
                lastName: post.lastName.value,
                teamId: Number(post.teamId.value),
                role: Number(post.role.value)
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-edit/user-edit.service.ts